import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { TybSharePage } from "./tyb-share";

@NgModule({
  declarations: [TybSharePage],
  imports: [IonicPageModule.forChild(TybSharePage)],
})
export class TybSharePageModule {}



// WEBPACK FOOTER //
// ./src/pages/tyb-share/tyb-share.module.ts